/**
 * Load GA4 event listeners
 * */

// view_item_list event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item_list
jQuery(document).on("pmw:browser:view-item-list", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// select_item event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#select_item
jQuery(document).on("pmw:browser:select-item", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// add_to_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_to_cart
jQuery(document).on("pmw:browser:add-to-cart", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// view_item event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item
jQuery(document).on("pmw:browser:view-item", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// add_to_wishlist event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_to_wishlist
jQuery(document).on("pmw:browser:add-to-wishlist", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// remove_from_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#remove_from_cart
jQuery(document).on("pmw:browser:remove-from-cart", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// begin_checkout event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#begin_checkout
jQuery(document).on("pmw:browser:begin-checkout", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// add_shipping_info event
jQuery(document).on("pmw:browser:add-shipping-info", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// add_payment_info event
jQuery(document).on("pmw:browser:add-payment-info", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// view_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_cart
jQuery(document).on("pmw:browser:view-cart", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});
	} catch (e) {
		console.error(e);
	}
});

// view search event
jQuery(document).on("pmw:browser:search", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});

	} catch (e) {
		console.error(e);
	}
});

// view order received page event
jQuery(document).on("pmw:browser:purchase", (event, payload) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;

		console.log("Google GA4 purchase event listener triggered");

		// ga4_server_and_browser_tracking experiment
		// https://app.asana.com/0/1110999795232049/1204453591507565
		// ga4e: if (wpmDataLayer?.pixels?.google?.analytics?.ga4?.mp_active) {
		// 	if (wpmDataLayer?.experiments?.ga4_server_and_browser_tracking) {
		// 		break ga4e
		// 	}
		// 	return
		// }

		// Deactivated for the ga4_server_and_browser_tracking experiment
		if (wpmDataLayer?.pixels?.google?.analytics?.ga4?.mp_active) return;
		if (!wpm.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		wpm.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		});

		// wpm.gtagLoaded().then(function () {
		// 	gtag("get", wpmDataLayer.pixels.google.analytics.ga4.measurement_id, "client_id", (client_id) => {
		// 		console.log("transaction_id: " + wpmDataLayer.order.number + " client_id: " + client_id)
		// 	})
		// })

	} catch (e) {
		console.error(e);
	}
});
